import { renderPrimitivesMethods } from "components/Topology/staticLayer/vectorElements/renderPrimitivesMethods";

const { drawRect } = renderPrimitivesMethods;

export const drawZoneBorderHelper = ({
  ctx,
  name,
  startX,
  startY,
  height,
  width,
}) => {
  const zonesData = [];
  zonesData.push({
    name,
    startX,
    startY,
    height,
    width,
  });

  zonesData.forEach(
    ({
      zoneStartX = startX,
      zoneStartY = startY,
      zoneWidth = width,
      zoneHeight = height,
    }) =>
      drawRect(ctx, zoneStartX, zoneStartY, {
        zoneWidth,
        zoneHeight,
        strokeWidth: 5,
        stroke: "tomato",
        fill: "transparent",
      }),
  );
};

export const getInteractiveElemKind = (
  isPasteEnabled,
  isConfigPasteEnabled,
) => {
  if (isConfigPasteEnabled) {
    return "pastConfigBtn";
  }
  if (isPasteEnabled) {
    return "pastBtn";
  }
  return "node";
};
